import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Phone, Menu, X, Flag } from "lucide-react";
import { CONTACTS } from "@/data/site";

const LINKS = [
  { label: "Services", href: "#services", testid: "nav-link-services" },
  { label: "24/7 Towing", href: "#towing", testid: "nav-link-towing" },
  { label: "Gallery", href: "#gallery", testid: "nav-link-gallery" },
  { label: "Manifesto", href: "#manifesto", testid: "nav-link-manifesto" },
  { label: "Location", href: "#location", testid: "nav-link-location" },
  { label: "Contact", href: "#contact", testid: "nav-link-contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header className="fixed top-0 inset-x-0 z-50 bg-carbon/90 backdrop-blur-md border-b border-steel">
      <div className="h-1 checkered-edge opacity-80" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between gap-4">
        <a href="#top" data-testid="nav-brand-logo" className="flex items-center gap-2 group">
          <span className="w-8 h-8 border border-steel bg-card flex items-center justify-center group-hover:border-hazard transition-colors duration-300">
            <Flag className="w-4 h-4 text-hazard" />
          </span>
          <span className="font-heading font-black uppercase text-xl tracking-tight leading-none">
            <span className="text-racing">GSX</span> <span className="chrome-text">Diesel</span>
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-7">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={l.testid}
              className="font-mono text-[11px] uppercase tracking-widest text-slate-400 hover:text-hazard transition-colors duration-300"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-2">
          <a
            href={CONTACTS.omar.tel}
            data-testid="nav-call-omar-button"
            className="flex items-center gap-2 px-4 py-2 bg-racing text-white font-heading font-bold uppercase text-sm tracking-wide emergency-pulse hover:bg-[#E01F1F] transition-colors duration-300"
          >
            <Phone className="w-3.5 h-3.5" /> Omar {CONTACTS.omar.phone}
          </a>
          <a
            href={CONTACTS.ray.tel}
            data-testid="nav-call-ray-button"
            className="flex items-center gap-2 px-4 py-2 border border-hazard/60 text-hazard font-heading font-bold uppercase text-sm tracking-wide hover:bg-hazard hover:text-carbon transition-colors duration-300"
          >
            <Phone className="w-3.5 h-3.5" /> Ray {CONTACTS.ray.phone}
          </a>
        </div>

        <button
          data-testid="nav-mobile-menu-button"
          onClick={() => setOpen(!open)}
          className="lg:hidden w-10 h-10 flex items-center justify-center border border-steel text-slate-300"
          aria-label="Toggle menu"
        >
          {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.35, ease: [0.16, 1, 0.3, 1] }}
            className="lg:hidden overflow-hidden border-t border-steel bg-carbon"
            data-testid="nav-mobile-menu"
          >
            <div className="px-6 py-6 flex flex-col gap-4">
              {LINKS.map((l) => (
                <a
                  key={l.href}
                  href={l.href}
                  onClick={() => setOpen(false)}
                  className="font-heading font-bold uppercase text-2xl text-slate-200 hover:text-hazard transition-colors"
                >
                  {l.label}
                </a>
              ))}
              <div className="flex flex-col gap-2 pt-4 border-t border-steel">
                <a href={CONTACTS.omar.tel} className="flex items-center justify-center gap-2 px-4 py-3 bg-racing text-white font-heading font-bold uppercase">
                  <Phone className="w-4 h-4" /> Call Omar {CONTACTS.omar.phone}
                </a>
                <a href={CONTACTS.ray.tel} className="flex items-center justify-center gap-2 px-4 py-3 border border-hazard text-hazard font-heading font-bold uppercase">
                  <Phone className="w-4 h-4" /> Call Ray {CONTACTS.ray.phone}
                </a>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
}
